type Button2 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const button2: Button2 = {
    'fontFamily': 'var(--plasma-typo-button2-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-button2-font-weight, 600)',
    'fontStyle': 'var(--plasma-typo-button2-font-style, normal)',
    'fontSize': 'var(--plasma-typo-button2-font-size, 0.875rem)',
    'letterSpacing': 'var(--plasma-typo-button2-letter-spacing, normal)',
    'lineHeight': 'var(--plasma-typo-button2-line-height, 1rem)'
};